import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import MigrationInProgress from "AppComponents/MigrationInProgress";

export default () => ({
  path: "migration-in-progress",
  component: withAsyncRouteLoading(
    () =>
      new Promise((cb, reject) => {
        require.ensure(
          [],
          () => {
            cb(MigrationInProgress);
          },
          err => {
            reject(err);
          }
        );
      })
  ),
  childRoutes: [],
});
